/* [BD feat] PDP Item Slider */
class BdItemSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.wartetAufSwiper = false;
    this.prevBtn = null;
    this.nextBtn = null;
    this._onScroll = null;
    this._masse = null;
  }

  connectedCallback() {
    this._initTabs();
    this._initNav();
    this._initSwiper();
  }

  _initTabs() {
    const tabs = this.querySelectorAll('.bd-pdp__inhalt-tab');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this._activateTab(tab, tab.dataset.inhalt);
      });
    });

    // Activate first tab on load to ensure correct initial state
    const firstTab = tabs[0];
    if (firstTab) {
      this._activateTab(firstTab, firstTab.dataset.inhalt, true);
    }
  }

  _activateTab(activeTab, inhalt, silent = false) {
    const tabs = this.querySelectorAll('.bd-pdp__inhalt-tab');
    tabs.forEach((t) => {
      t.classList.toggle('bd-pdp__inhalt-tab--active', t === activeTab);
      t.setAttribute('aria-selected', t === activeTab ? 'true' : 'false');
    });

    const slides = this.querySelectorAll('.swiper-slide[data-inhalts]');
    slides.forEach((slide) => {
      const inhalts = (slide.dataset.inhalts || '').split(' ').filter(Boolean);
      const match = inhalts.includes(inhalt);
      slide.classList.toggle('bd-pdp__item-card--hidden', !match);
    });

    if (!silent) {
      this._reinitSwiper();
    }
    this._updateNav();
  }

  /* [RR feat] Pfeiltasten. Am Schreibtisch laesst sich nicht wischen, deshalb zwei Tasten.
     Sie bedienen den Swiper genauso wie den Rueckfall auf das Scrollen des Browsers. */
  _initNav() {
    this.prevBtn = this.querySelector('[data-bd-item-prev]');
    this.nextBtn = this.querySelector('[data-bd-item-next]');
    if (!this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this._step(-1));
    this.nextBtn.addEventListener('click', () => this._step(1));

    const container = this.querySelector('.swiper');
    if (container) {
      this._onScroll = () => this._updateNav();
      container.addEventListener('scroll', this._onScroll, { passive: true });

      /* [RR fix] Die Breiten stehen erst fest, wenn bd-main-product.css geladen hat. Das
         passiert auf Produktseiten spaeter, deshalb wird bei jeder Groessenaenderung neu
         bewertet. Ohne das blieben die Tasten aus einer zu fruehen Messung ausgeblendet. */
      if (window.ResizeObserver) {
        this._masse = new ResizeObserver(() => this._updateNav());
        this._masse.observe(container);
        const wrapper = this.querySelector('.swiper-wrapper');
        if (wrapper) this._masse.observe(wrapper);
      }
    }

    this._updateNav();
  }

  _stepAmount(width) {
    // Ein Schritt entspricht so vielen ganzen Karten, wie in den Ausschnitt passen, mindestens einer
    const card = this.querySelector('.swiper-slide:not(.bd-pdp__item-card--hidden)');
    const cardWidth = card ? card.getBoundingClientRect().width + 12 : width * 0.8;
    const steps = Math.max(1, Math.floor(width / cardWidth));
    return Math.min(steps * cardWidth, Math.max(cardWidth, width));
  }

  _step(direction) {
    const container = this.querySelector('.swiper');
    if (!container) return;

    if (this.swiper) {
      const amount = this._stepAmount(this.swiper.size);
      const min = this.swiper.maxTranslate();
      const target = Math.min(0, Math.max(min, this.swiper.translate - direction * amount));
      this.swiper.translateTo(target, 400);
      setTimeout(() => this._updateNav(), 450);
      return;
    }

    container.scrollBy({ left: direction * this._stepAmount(container.clientWidth), behavior: 'smooth' });
    setTimeout(() => this._updateNav(), 450);
  }

  _updateNav() {
    if (!this.prevBtn || !this.nextBtn) return;
    const container = this.querySelector('.swiper');
    if (!container) return;

    let atStart;
    let atEnd;
    let fits;

    if (this.swiper) {
      const min = this.swiper.maxTranslate();
      atStart = this.swiper.translate >= -1;
      atEnd = this.swiper.translate <= min + 1;
      fits = this.swiper.virtualSize - this.swiper.size <= 1;
    } else {
      const max = container.scrollWidth - container.clientWidth;
      atStart = container.scrollLeft <= 1;
      atEnd = container.scrollLeft >= max - 1;
      fits = max <= 1;
    }

    this.classList.toggle('bd-pdp__item-slider-wrapper--nav-off', fits);
    this.prevBtn.disabled = atStart;
    this.nextBtn.disabled = atEnd || fits;
  }

  _reinitSwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this._initSwiper();
  }

  _initSwiper() {
    /* [RR fix] Ohne die Swiper-Bibliothek blieb die Leiste beim ersten Artikel stehen und war
       nicht mehr zu bewegen. Die Klasse --no-swiper schaltet auf natives Wischen um; sie wird
       erst entfernt, wenn Swiper wirklich uebernimmt. Kommt die Bibliothek verspaetet, holen
       wir sie in ein paar Anlaeufen nach. */
    if (typeof Swiper === 'undefined') {
      this.classList.add('bd-pdp__item-slider-wrapper--no-swiper');
      this._updateNav();
      if (!this.wartetAufSwiper && window.bdWhenSwiper) {
        this.wartetAufSwiper = true;
        window.bdWhenSwiper(() => {
          this.wartetAufSwiper = false;
          this._initSwiper();
        });
      }
      return;
    }

    const container = this.querySelector('.swiper');
    if (!container) return;

    /* [RR fix] Wurde vor der Uebernahme schon mit den Pfeiltasten geblaettert, steckt die
       Position im scrollLeft des Ausschnitts. Sie wird an Swiper uebergeben und
       zurueckgesetzt, sonst zaehlen beide Verschiebungen doppelt. */
    const vorlauf = container.scrollLeft || 0;
    container.scrollLeft = 0;

    this.swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 400,
      freeMode: true,
      freeModeMomentum: true,
      grabCursor: true,
      simulateTouch: true,
      followFinger: true,
      threshold: 6,
      touchRatio: 1.2,
      resistanceRatio: 0.75,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
    });

    this.classList.remove('bd-pdp__item-slider-wrapper--no-swiper');

    if (vorlauf > 0) {
      const ziel = Math.max(this.swiper.maxTranslate(), -vorlauf);
      this.swiper.translateTo(ziel, 0);
    }

    this.swiper.on('setTranslate', () => this._updateNav());
    this.swiper.on('transitionEnd', () => this._updateNav());
    this.swiper.on('resize', () => this._updateNav());
    this.swiper.on('update', () => this._updateNav());
    this._updateNav();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.wartetAufSwiper = true;
    const container = this.querySelector('.swiper');
    if (container && this._onScroll) container.removeEventListener('scroll', this._onScroll);
    if (this._masse) {
      this._masse.disconnect();
      this._masse = null;
    }
  }
}

if (!customElements.get('bd-item-slider')) {
  customElements.define('bd-item-slider', BdItemSlider);
}
/* [BD feat] PDP Item Slider */
